/* eslint-disable import/no-duplicates */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// src/components/FooterTabs.js
import React, { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { HeaderContext } from '../../../contexts/headerContext';
import useMenu from '../../../hooks/useMenu';
import { useFirebase } from '../../../contexts/ssr-firebase-context';
import { useUser } from '../../../contexts/ssr-user-context';

const nIASlegaCyRedirectList = ['/student'];

// eslint-disable-next-line no-unused-vars
function FooterTabs() {
  const router = useRouter();
  const [activeRoute, setActiveRoute] = useState(router.pathname);
  const { remoteConfig: remoteConfigData, loading } = useFirebase();
  const { setShowProfilePopup } = useContext(HeaderContext);
  const [menuList, setMenuList] = useState([]);
  const { user } = useUser();

  const localMenus = useMenu(user);

  useEffect(() => {
    if (remoteConfigData?.webHomeMenus?.mobileFooterFixedMenu) {
      const visibleMenus = localMenus
        .map((localItem) => {
          const remoteItem = remoteConfigData.webHomeMenus.mobileFooterFixedMenu.find((remote) => remote.label === localItem.label);
          return remoteItem ? { ...remoteItem, icon: localItem.icon, iconFill: localItem.iconFill } : null;
        })
        .filter(Boolean); // Remove null values if any

      // console.log('visibleMenus', visibleMenus);
      setMenuList(visibleMenus);
    }
  }, [remoteConfigData]);

  const handleShowProfile = () => {
    setShowProfilePopup(true);
  };
  // const redirectPage = (url) => {
  //   router.push(url);
  // };

  // eslint-disable-next-line no-unused-vars
  const redirectPage = (route, label) => {
    // console.log('route, label', route, label)
    if (nIASlegaCyRedirectList.some((prefix) => route.startsWith(prefix))) {
      const host = window.location.origin;
      const url = `${host}${route}`;
      // '__blank'
      // window.location.href = url;
      window.open(url, '__blank');
    } else {
      router.push(route);
    }
  };

  if (loading) {
    return (
      <div className="relative" />
    );
  }
  return (
    <div
      className="lg:hidden fixed bottom-0 w-full bg-white border-t border-gray-200 shadow-lg z-10"
    >
      {/* { !isUserPaid ? getMenu1() : getMenu2() } */}
      <div className="flex justify-around items-center py-2">
        {menuList?.map((item, index) => (
          <div
            key={item.label}
            onClick={item.label === 'Profile' ? handleShowProfile : () => redirectPage(item.route)}
            className={`${
              activeRoute === item.route
                ? 'menu'
                : ''
            }`}
          >
            <div
            // className="flex flex-col items-center"
              className={`flex flex-col items-center cursor-pointer ${
                activeRoute === item.route
                  ? 'text-customBlue'
                  : 'text-grayLight hover:bg-blue-200'
              }`}
              onClick={() => setActiveRoute(item.route)}
            >
              {/* <HomeIcon className="h-6 w-6 text-blue-500" /> */}
              <Image
                width={24}
                height={24}
                src={
                activeRoute === item.route ? menuList[index].iconFill : menuList[index].icon
              }
                alt={`${item.label} Icon`}
              />
              <span
                className={`text-sm font-medium ${
                  activeRoute === item.route
                    ? 'text-customBlue'
                    : 'text-grayLight'
                }`}
              >
                {item.label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FooterTabs;
